import React from 'react';
import { useSelector } from 'react-redux';
import DashHome from '../DashHome';
import Integration from '../Integration';

export default function Home() {
  const isAdmin = useSelector((state) => state.auth.user.flag_admin);

  if (isAdmin === 4) return <Integration />;
  return <DashHome />;
}
